import "./ProjectProcess.css";

// ---------------------------------------------------------------------------
// Данные этапов
// ---------------------------------------------------------------------------
const STEPS = [
  {
    number: "01",
    title: "Обследование и проект",
    tag: "СРО",
    description:
      "Выезжаем на объект, фиксируем требования, трассы, узлы связи и готовим техническое решение или проектную документацию.",
  },
  {
    number: "02",
    title: "Поставка и монтаж",
    tag: "СРО",
    description:
      "Поставляем оборудование, строим СКС, ВОЛС, СОТ, СКУД, серверные и телекоммуникационные узлы.",
  },
  {
    number: "03",
    title: "Настройка и интеграция",
    tag: null,
    description:
      "Настраиваем активное оборудование, VLAN, VPN, Wi-Fi, серверные роли, доступы и интеграцию с внутренними системами.",
  },
  {
    number: "04",
    title: "Документация и сервис",
    tag: "24/7",
    description:
      "Передаём исполнительную документацию, обучаем ответственных и берём инфраструктуру на сопровождение.",
  },
];

// ---------------------------------------------------------------------------
// Компонент
// ---------------------------------------------------------------------------
export default function ProjectProcess() {
  return (
    <section className="process-section">
      {/* декоративный blob справа */}
      <div className="process-blob" />

      <div className="process-container">

        {/* ── Заголовок ── */}
        <div className="process-heading">
          <div className="process-eyebrow">Прозрачный процесс</div>
          <h2 className="process-title">Как мы ведём проект</h2>
        </div>

        {/* ── Этапы ── */}
        <div className="process-grid">
          {STEPS.map((step, idx) => (
            <div key={step.number} className="process-step">

              {/* большой номер */}
              <div className="process-step__number">{step.number}</div>

              {/* точка-коннектор */}
              <div className="process-step__connector">
                <div className="process-step__dot" />
                {idx < STEPS.length - 1 && (
                  <div className="process-step__line" />
                )}
              </div>

              {/* контент */}
              <div className="process-step__body">
                <div className="process-step__title-row">
                  <h3 className="process-step__title">{step.title}</h3>
                  {step.tag && (
                    <span className="process-step__tag">{step.tag}</span>
                  )}
                </div>
                <p className="process-step__desc">{step.description}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}